import { configureStore } from "@reduxjs/toolkit";

import { initialState, reducer } from "./reducer";

const store = configureStore({
    reducer: reducer(initialState),
    devTools: {
        name: "jsw-interactive-roadmap/global"
    }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
